import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVerticalCircle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFlipVerticalCircle12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.348 9.011a3.3 3.3 0 0 0 0-6.022v-.966A4.2 4.2 0 0 1 10.198 6l-.006.215a4.2 4.2 0 0 1-2.844 3.762zM5.555 1.05a.45.45 0 0 1 .9 0v9.9a.45.45 0 0 1-.9 0zM1.804 5.783a4.2 4.2 0 0 1 2.844-3.761v.967a3.3 3.3 0 0 0 0 6.022v.966A4.2 4.2 0 0 1 1.798 6z"
            />
        </svg>
    );
}
export default memo(IconFlipVerticalCircle12);
